export const getOperatingSystem = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera

  if (/android/i.test(userAgent)) {
    return 'android'
  }

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return 'iOS'
  }

  return 'desktop'
}

export const getDeviceType = () => {
  const os = getOperatingSystem()

  if (os === 'desktop') {
    return 'desktop'
  }

  return 'mobile'
}

export const getDeviceDimension = () => {
  return {
    height: window.innerHeight,
    width: window.innerWidth,
  }
}
